export default {
  namespaced: true,
  state: {
    test: false,
  },
};
